import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, notification } from 'antd';
import { formatMissingItems } from 'library/optimiserStatusWarning';

const NOTIF_KEY = 'optimiser-readiness-warning';

const OptimiserReadinessWarning = ({ violations, onClose }) => {
  useEffect(() => {
    if (!violations || !violations.length) return;

    const email = violations[0].record_label;
    const items = formatMissingItems(violations);
    const handleOk = () => {
      notification.close(NOTIF_KEY);
      onClose();
    };
    const description = (
      <span>
        {'User '}
        <b>{email}</b>
        {' was saved, but the following Optimiser readiness issues remain:'}
        <ul style={{ margin: '8px 0 0', paddingLeft: 20 }}>
          {items.map(item => <li key={item}>{item}</li>)}
        </ul>
      </span>
    );
    const btn = (
      <Button size="small" type="primary" onClick={handleOk}>
        OK
      </Button>
    );
    notification.warning({
      key: NOTIF_KEY,
      message: 'Saved with Optimiser readiness issues',
      description,
      placement: 'bottomRight',
      duration: 0,
      btn,
      onClose
    });
  }, [violations]);

  return null;
};

OptimiserReadinessWarning.propTypes = {
  violations: PropTypes.array,
  onClose: PropTypes.func
};

OptimiserReadinessWarning.defaultProps = {
  violations: null,
  onClose() {}
};

export default OptimiserReadinessWarning;
